import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  WithStyles,
  createStyles,
  withStyles,
} from '@material-ui/core';
import React, { useCallback } from 'react';

import { AspectContainer } from '../AspectContainer';
import { Content } from '../../../Content';
import { constructContent } from '../../../ContentDispatcher';

const styles = createStyles({
  dialogPaper: {
    height: 'calc(100% - 64px)',
  },
  dialogContent: {
    height: 'calc(100% - 80px)',
  },
});
interface ContentPopupProps extends WithStyles<typeof styles> {
  content: Content;
  closeBtnText?: string;
  onCloseRequested: () => void;
}

const ContentPopup: React.FC<ContentPopupProps> = ({
  content,
  classes,
  ...props
}) => {
  const createContent = useCallback(() => {
    return (
      <div className="popup-body" style={{ height: '100%' }}>
        {constructContent(content)}
      </div>
    );
  }, [content]);

  return (
    <Dialog
      open={true}
      scroll="body"
      onClose={props.onCloseRequested}
      fullWidth={true}
      maxWidth={content.dialogOptions?.maxWidth ?? 'lg'}
      classes={
        content.dialogOptions?.fullHeight
          ? { paper: classes.dialogPaper }
          : undefined
      }
    >
      {content?.title && <DialogTitle>{content.title}</DialogTitle>}
      <DialogContent
        classes={
          content.dialogOptions?.fullHeight
            ? { root: classes.dialogContent }
            : undefined
        }
      >
        {content.aspect ? (
          <AspectContainer aspect={content.aspect}>
            {createContent()}
          </AspectContainer>
        ) : (
          createContent()
        )}
      </DialogContent>
      <DialogActions>
        <Grid justify="flex-start" container spacing={2}>
          {content.links?.map(({ text, href }) => (
            <Grid item key={text}>
              <Button onClick={() => window.open(href)}>{text}</Button>
            </Grid>
          ))}
        </Grid>
        <Button onClick={props.onCloseRequested}>
          {props.closeBtnText ?? 'Close'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default withStyles(styles)(ContentPopup);
